import React from 'react'
import styled from 'styled-components'

export const ReceiptMainContentHeader = ({
  title,
  invoiceRegistered,
  ourZipCode,
  ourAddress1,
  ourAddress2,
  receiptName,
  ourCompanyName,
  ourInvoiceRegistrationNumber,
  totalAmountIncludingTax,
  reservationId,
  reservationStatus,
}) => {
  const addressText = [ourZipCode, ourAddress1, ourAddress2]
    .filter(Boolean)
    .join('\n')

  return (
    <StyledMainContentsHeader>
      <StyledMainContentNameContainer>
        <StyledReceiptName>
          {receiptName}
          <StyledReceiptNameHonorific>様</StyledReceiptNameHonorific>
        </StyledReceiptName>

        <StyledCompanyInfo>
          <StyledCompanyName>{ourCompanyName}</StyledCompanyName>
          <StyledCompanyAddress>{addressText}</StyledCompanyAddress>
          {invoiceRegistered && (
            <>
              <StyledRegistrationNumber>
                登録番号
                <StyledRegistrationNumberValue>
                  {ourInvoiceRegistrationNumber}
                </StyledRegistrationNumberValue>
              </StyledRegistrationNumber>
              <StyledRegistrationNumberNote>
                本{title}は、インボイス登録事業者の代理
                <br />
                でスペースマーケットが発行しています。
              </StyledRegistrationNumberNote>
            </>
          )}
          <dd>
            <StyledSealImageWrap
              src="//cdn.spacemarket.net/assets/print/company_seal-75b3bc1b53503154585a07af2419e421.jpg"
              alt="Company_Seal"
            />
          </dd>
        </StyledCompanyInfo>
      </StyledMainContentNameContainer>

      <StyledTotalPayWrapper>
        <StyledTotalPay>
          <StyledTotalPayLabel>金額</StyledTotalPayLabel>
          <StyledTotalPayText>
            ￥{totalAmountIncludingTax.toLocaleString()}-
          </StyledTotalPayText>
        </StyledTotalPay>
      </StyledTotalPayWrapper>

      {reservationStatus === 10 /* Refunded */ && (
        <StyledReceiptProviso>
          予約ID：{reservationId}のスペースのキャンセルに伴う事務手数料として
        </StyledReceiptProviso>
      )}
    </StyledMainContentsHeader>
  )
}

const StyledMainContentsHeader = styled.div`
  padding: 0 0 16px;
`
const StyledMainContentNameContainer = styled.div`
  display: flex;
  justify-content: space-between;
`
const StyledTotalPayWrapper = styled.div`
  display: inline-block;
  padding: 0 24px 16px 0;
  border-bottom: 1px solid #222;
`

const StyledReceiptName = styled.h2`
  font-size: 24px;
`
const StyledReceiptNameHonorific = styled.span`
  margin-left: 12px;
  font-size: 18px;
`
const StyledCompanyInfo = styled.dl`
  flex-shrink: 0;
  position: relative;
  padding: 16px 0;
  page-break-inside: avoid;
`
const StyledCompanyName = styled.dt`
  position: relative;
  z-index: 100;
  font-size: 18px;
`
const StyledCompanyAddress = styled.dd`
  position: relative;
  z-index: 100;
  font-size: 14px;
  margin: 20px 0 0;
  line-height: 1.35;
  white-space: pre-wrap;
`

const StyledRegistrationNumber = styled.dd`
  position: relative;
  z-index: 100;
  font-size: 14px;
  margin: 24px 0 0;
`

const StyledRegistrationNumberValue = styled.span`
  margin-left: 12px;
`

const StyledRegistrationNumberNote = styled.dd`
  position: relative;
  z-index: 100;
  font-size: 12px;
  margin: 12px 0 0;
  line-height: 1.35;
`

const StyledSealImageWrap = styled.img`
  top: 32px;
  left: 100px;
  position: absolute;
  width: 100px;
  height: 100px;
`

const StyledTotalPay = styled.dl`
  margin-top: 80px;
`
const StyledTotalPayLabel = styled.dt`
  font-size: 14px;
  display: inline;
`
const StyledTotalPayText = styled.dd`
  margin-left: 12px;
  font-size: 24px;
  display: inline;
`
const StyledReceiptProviso = styled.p`
  font-size: 14px;
  margin-top: 12px;
`
